<template>
    <default-item class="pancho_willies_drink_item--container" :item="item" :pricing-types="pricingTypes"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-06-07 (1.0.0) (jhoward)
 *      - <biminiFoodItem> copied to <panchoWilliesDrinkItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <panchoWilliesDrinkItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'pancho-willies-drink-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
})
</script>

<style scoped>
.pancho_willies_food_item--container {
  font-family: AmerigoBT, serif;
}

.pancho_willies_food_item--container:deep(.menu--item-highlighted) {
  background-color: #f7f3eb;
}
</style>